"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.postPayment = exports.getWallets = exports.getManifest = void 0;

var _Http = require("./Http");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var resource = "tsys";
var resourceVersion = "1";
var baseUrl = "".concat(resource, "/").concat(resourceVersion, "/");
/**
 * Retrieve TSEP manifest URL
 *
 * @param {number} providerId
 * @returns manifest URL string
 */

var getManifest = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(providerId) {
    var res;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _Http.get)("".concat(baseUrl, "manifest?providerId=").concat(providerId));

          case 2:
            res = _context.sent;
            return _context.abrupt("return", res.data.manifest);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getManifest(_x) {
    return _ref.apply(this, arguments);
  };
}();
/**
 * Retrieve wallets for given accountId, other parameters are optional
 *
 * @param {number} accountId
 * @param {boolean} [includeArchived=false]
 * @param {number} [method=0]
 * @param {boolean} [retrievePlanStatus=true]
 * @returns array of wallet data
 */


exports.getManifest = getManifest;

var getWallets = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(accountId) {
    var includeArchived,
        method,
        retrievePlanStatus,
        params,
        res,
        _args2 = arguments;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            includeArchived = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : false;
            method = _args2.length > 2 && _args2[2] !== undefined ? _args2[2] : 0;
            retrievePlanStatus = _args2.length > 3 && _args2[3] !== undefined ? _args2[3] : true;
            params = {
              accountId: accountId,
              includeArchived: includeArchived,
              method: method,
              retrievePlanStatus: retrievePlanStatus
            };
            _context2.next = 6;
            return (0, _Http.get)(baseUrl + "wallets", params);

          case 6:
            res = _context2.sent;
            return _context2.abrupt("return", res.data || []);

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function getWallets(_x2) {
    return _ref2.apply(this, arguments);
  };
}();
/**
 * Post an online payment
 *
 * @param {object} data
 * @returns data on processed payment, used for showing receipt info
 */


exports.getWallets = getWallets;

var postPayment = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(data) {
    var res;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _Http.post)(baseUrl + "onlinePayment", data);

          case 2:
            res = _context3.sent;
            return _context3.abrupt("return", res.data);

          case 4:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function postPayment(_x3) {
    return _ref3.apply(this, arguments);
  };
}();

exports.postPayment = postPayment;